import { getDocuments } from '@services/external/translations.api';
import React from 'react';
import { TDocumentCatalog } from '../../types/documents.types';

/**
 * Get documents from translations api
 * @returns documents
 */
export function useDocuments() {
  const [documents, setDocuments] = React.useState<TDocumentCatalog | null>(null);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    const fetch = async () => {
      setLoading(true);

      try {
        // TODO: Docs are only on EN, so add another langs
        const response = await getDocuments('en');
        const result = {} as TDocumentCatalog;

        for (const doc of response.data) {
          result[doc.name] = doc;
        }

        setDocuments(result);
      } catch (error) {
        console.log('useDocuments', error);
        setDocuments(null);
      } finally {
        setLoading(false);
      }
    };

    fetch();
  }, []);

  return { documents, loading };
}

export default useDocuments;
